import React from "react";
import "./Contest.css";
import contestPoster from "../../assets/contest poster.jpeg";

const Contest: React.FC = () => {
  const googleFormUrl = "https://tumblbug.com/humananimal/community/creator/279c912a-940e-4050-b80d-7b7e4a105d37"; // Placeholder link

  return (
    <section id="contest" className="contest-section">
      <div className="contest-container">
        <div className="contest-text">
          <h2 className="contest-title">
            3000자만 썼는데
            <br /> 작가 데뷔에 가까워지는 공모전
          
          </h2>
          <p className="contest-body">
            여러분이 쓴 3,000자는 현역 작가의 피드백을 통해 더 단단해질 것이며,
            우수작에게는 총 100만원의 창작 지원금, 전자책 평생 무료 소장권,
            웹소설 작가 1인 브랜딩 컨설팅, 출판의 기회 등의 리워드가 제공됩니다.
          </p>
          <a
            href={googleFormUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="contest-cta-button"
          >
            공모전 상세 확인 및 신청하기
          </a>
        </div>
        <div className="contest-image">
          <a href={googleFormUrl} target="_blank" rel="noopener noreferrer">
            <img src={contestPoster} alt="공모전 포스터" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contest;
